import { mediaType } from '@components/libs/typeInterface';
import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import { ArrowLeft } from '../../../../static/svg/ArrowLeft';
import { ArrowRight } from '../../../../static/svg/ArrowRight';
import BigSlider from './BigSlider';
import ThumbSlider from './ThumbSlider';

interface IProductSlider {
  media: mediaType[];
  name: string;
  setShowZoomModal: (x: boolean) => void;
  setInitialImage: (x: mediaType) => void;
}

const ProductSlider = (props: IProductSlider) => {
  const { media, name, setShowZoomModal, setInitialImage } = props;
  const [nav1, setNav1] = useState<Slider | null>(null);
  const [nav2, setNav2] = useState<Slider | null>(null);
  const [slider1, setSlider1] = useState<Slider | null>(null);
  const [slider2, setSlider2] = useState<Slider | null>(null);

  useEffect(() => {
    setNav1(slider1);
    setNav2(slider2);
  });

  // tslint:disable-next-line: no-shadowed-variable
  function PrevArrow(props: { className?: string; style?: object; onClick?: () => void }) {
    const { className, style, onClick } = props;
    return (
      <div
        className={`lg:w-16 cursor-pointer flex justify-center items-center lg:transform lg:translate-y-1 ${className}`}
        style={{ ...style, display: 'flex' }}
        onClick={onClick}
      >
        <ArrowLeft className="transform lg:rotate-90 text-customColors-500" />
      </div>
    );
  }

  // tslint:disable-next-line: no-shadowed-variable
  function NextArrow(props: { className?: string; style?: object; onClick?: () => void }) {
    const { className, style, onClick } = props;
    return (
      <div
        className={`lg:w-16 cursor-pointer flex justify-center items-center lg:transform lg:-translate-y-1 ${className}`}
        style={{ ...style, display: 'flex' }}
        onClick={onClick}
      >
        <ArrowRight className="transform lg:rotate-90 text-customColors-500" />
      </div>
    );
  }

  const settingsMain = {
    dots: false,
    arrows: false,
    fade: true,
    infinite: false,
    centerMode: false,
    asNavFor: '.slider-nav'
  };

  const settingsThumbs = {
    slidesToShow: 5,
    slidesToScroll: 4,
    asNavFor: '.slider-for',
    vertical: true,
    dots: false,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    focusOnSelect: true,
    verticalSwiping: true,
    infinite: false,
    variableWidth: false,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          vertical: false,
          slidesToShow: 4,
          slidesToScroll: 4
        }
      }
    ]
  };

  return (
    <>
      <div className="w-full flex xs:flex-wrap lg:flex-nowrap lg:flex-row justify-start">
        <div className="xs:mt-2 lg:mt-0 lg:mr-2 slider-nav-container relative xs:order-1 lg:order-0">
          <ThumbSlider
            media={media}
            nav1={nav1}
            settingsThumbs={settingsThumbs}
            setSlider2={setSlider2}
          />
        </div>
        <div className="relative bg-leaf bg-contain bg-bottom bg-no-repeat pro-slider xs:order-0 lg:order-1">
          <BigSlider
            setShowZoomModal={setShowZoomModal}
            setInitialImage={setInitialImage}
            name={name}
            media={media}
            nav2={nav2}
            settingsMain={settingsMain}
            setSlider1={setSlider1}
          />
        </div>
      </div>
    </>
  );
};

export default ProductSlider;
